import { render, staticRenderFns } from "./ActionChance.vue?vue&type=template&id=5684f5d2"
import script from "./ActionChance.vue?vue&type=script&lang=js"
export * from "./ActionChance.vue?vue&type=script&lang=js"
import style0 from "./ActionChance.vue?vue&type=style&index=0&id=5684f5d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports